import { render, staticRenderFns } from "./topicsSearch.vue?vue&type=template&id=b585e45c&"
import script from "./topicsSearch.vue?vue&type=script&lang=ts&"
export * from "./topicsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./topicsSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports